exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__crypto-chart___1jWoQ{position:absolute;bottom:0;right:0;left:0;top:40%;display:flex;width:100%}.styles__crypto-chart___1jWoQ canvas{height:100%!important;width:100%!important}", ""]);

// exports
exports.locals = {
	"crypto-chart": "styles__crypto-chart___1jWoQ"
};